<template>
  <div class="thr" oncontextmenu="return false">
      <div class="items">
          <div class="one-items" @click="oneLook()">
              <div class="one-item">
                    <div class="one-history">发展历程</div>
                    <div class="one-discript">公司自成立以来，发展迅速，为各行业领<br/>域提供专业的定制化解决方案</div>
                    <div class="one-discriptp">公司自成立以来，发展迅速，为各行业领域提供<br/>专业的定制化解决方案</div>
                    <!-- <router-link to="/about/history" class="one-look">立即查看></router-link> -->
                    <a  class="one-look">立即查看></a>
              </div>
          </div>
          <div class="two-items"  @click="twoLook()">
              <div class="two-item">
                  <div class="one-history">加入我们</div>
                    <div class="one-discript">我们正在寻找才华横溢、怀揣梦想的小伙<br/>伴，和我们一起做充满挑战的事情</div>
                    <div class="one-discriptp">我们正在寻找才华横溢、怀揣梦想的小伙伴，<br/>和我们一起做充满挑战的事情</div>
                    <!-- <router-link to="/about/join" class="one-look">立即查看></router-link> -->
                    <a class="one-look">立即查看></a>
              </div>
          </div>
          <div class="three-items" @click="threeLook()">
              <div class="three-item">
                  <div class="one-history">商务合作</div>
                  <div class="one-discript">我们非常希望听到你的建议或想法，同时<br/>非常期待您的加盟！</div>
                <div class="one-discriptp">我们非常希望听到你的建议或想法，<br/>同时非常期待您的加盟！</div>
                <!-- <router-link to="/about/bcoopera" class="one-look">立即查看></router-link> -->
                <a  class="one-look">立即查看></a>
              </div>
          </div>
      </div>
  </div>
</template>

<script>

export default {
  name:'thr',

  methods:{
      oneLook:function(){
          this.$router.push({path:'/about/history'});
           document.body.scrollTop = 0;        
          document.documentElement.scrollTop = 0
      },
      twoLook:function(){
          this.$router.push({path:'/about/join'});
          document.body.scrollTop = 0;        
          document.documentElement.scrollTop = 0
      },
      threeLook:function(){
          this.$router.push({path:'/about/bcoopera'});
          document.body.scrollTop = 0;        
          document.documentElement.scrollTop = 0
      }
  }
}
</script>

<style scoped>
.one-discriptp{
    display: none;
}

.items{
    width: 1200px;
    height: 250px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 60px 0px 100px;
}
.one-items,.two-items,.three-items{
    width: 380px;
	height: 250px;
	background-color: #fafafa;
    display: flex;
    justify-content: center;
    align-items: center;
}
.one-item,.two-item,.three-item{
    width: 296px;
    height: 146px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
}
.one-history{
    font-size: 18px;
	font-family: 微软雅黑;
	letter-spacing: 0px;
	color: #666666;
}
.one-discript{
    font-size: 16px;
	font-family: 微软雅黑;
	letter-spacing: 0px;
	color: #666666;
    text-align: center;
    line-height: 30px;
}
.one-look{
    font-size: 14px;
	font-family: 微软雅黑;
	letter-spacing: 0px;
	color: #1a8bff;
    cursor: pointer;
}
@media screen and (max-width:1200px){
    .items{
        transform: scale(0.8);
    }
}

/* 手机 */
@media screen and (max-width:768px){
    .one-discript{
        display: none;
    }

.one-discriptp{
    display: block;
}
    .thr{
        width: 100%;
     display: flex;
    justify-content: center;
    align-items: center;
    }
    .thr .items{
        transform: scale(1);
        width: 90%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        margin: 25px 0px 50px;
    }
    .one-items,.two-items,.three-items{
    width: 100%;
    height: 115px;
}
.two-items,.three-items{
    margin-top: 15px;
}
.one-item,.two-item,.three-item{
    width: 85%;
    height: 77px;
}
.one-history{
    font-size: 12px;
	font-family:'Times New Roman', Times, serif;
	letter-spacing: 0.5px;
	color: #666666;
}
.one-discriptp{
    font-size: 11px;
	font-family:'Times New Roman', Times, serif;
	letter-spacing: 0px;
	color: #666666;
    text-align: center;
    line-height: 18px;
}
.one-look{
    font-size: 11px;
	font-family:'Times New Roman', Times, serif;
	letter-spacing: 0px;
	color: #1a8bff;
    cursor: pointer;
}
}
</style>





// WEBPACK FOOTER //
// src/components/aboutUs/thr.vue